import {
  DateField,
  Field,
} from '../../util/components/resource/resource-fields';
import { ApiResource } from '../api-resource';
import { Endpoint } from '../api.decorators';
import { Camp } from '../camp/camp.model';
import { Course } from '../course/course.model';
import { Onboarding } from '../onboarding/onboarding.model';
import { Staff } from '../staff/staff.model';
import { Workshop } from '../workshop/workshop.model';
import {
  ActivityData,
  ApplicationStatus,
  CertaintyLevel,
} from './lib/application.interfaces';
import { ActivityRole } from '../activity/lib/activity.interfaces.js';
import { extractPeriod } from './lib/application.util';

@Endpoint('applications', 'Application')
export class Application extends ApiResource<Application> {
  @Field({ label: $localize`Status`, type: () => ApplicationStatus })
  status!: ApplicationStatus;

  @Field({ label: $localize`Certainty level`, type: () => CertaintyLevel })
  certaintyLevel!: CertaintyLevel;

  @Field({ includeFilter: false })
  comments!: {
    message: string;
    postedAt?: Date;
    postedBy?: string;
  }[];

  @Field({ includeFilter: false })
  activity!: ActivityData;

  @DateField({ label: $localize`Checked at` })
  checkedAt?: Date;

  @Field({ includeFilter: false })
  onboarding?: Onboarding;

  @Field({ label: $localize`Camp` })
  camp?: Camp;

  @Field({ label: $localize`Course` })
  course?: Course;

  @Field({ label: $localize`Workshop` })
  workshop?: Workshop;

  @Field({ label: $localize`Staff` })
  staff!: Staff;

  @Field({ label: $localize`Checked by` })
  checkedBy?: Staff;

  @Field({ label: $localize`Roles`, type: () => ActivityRole })
  roles!: ActivityRole[];

  get target() {
    const target = this.camp || this.course || this.workshop;
    if (!target) throw new Error('Application is missing a target.');
    return target;
  }

  get rootTarget() {
    const target = this.camp || this.course?.camp || this.workshop;
    if (!target) {
      let message = 'Application is missing a root target.';
      if (this.course) message += ' Has `course` but `course.camp` is absent.';
      throw new Error(message);
    }
    return target;
  }

  get name() {
    if (this.workshop) {
      return this.workshop.theme?.name;
    }

    if (this.course) {
      return this.course.theme?.name;
    }

    if (this.camp) {
      return `${this.camp.location?.name} ${extractPeriod(this)}`;
    }

    return '';
  }

  get statusText() {
    return `${this.status} (${this.certaintyLevel})`;
  }
}
